var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHelpIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "11px",
    height: "18px",
    viewBox: "0 0 11 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "BC4C384E-1671-494A-AE5A-77114D3A9509") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Manager-|-My-Account-Dropdown",
    transform: "translate(-1676.000000, -136.000000)",
    fill: "#023B93",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(1652.000000, 70.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(24.000000, 66.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 5,
    cy: 17,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,5.22988506 C0,5.71264368 0.426273623,6.11494253 0.93780197,6.11494253 C1.44933032,6.11494253 1.87560394,5.71264368 1.87560394,5.22988506 C1.87560394,3.29885057 3.49544371,1.77011494 5.5415571,1.77011494 C7.58767048,1.77011494 9.20751025,3.29885057 9.20751025,5.22988506 C9.20751025,6.75862069 8.09919883,8.12643678 6.56461379,8.6091954 C5.37104765,8.93103448 4.60375513,9.97701149 4.60375513,11.0229885 C4.60375513,11.6666667 4.60375513,13.1149425 4.60375513,13.1149425 C4.60375513,13.5977011 5.03002875,14 5.5415571,14 C6.05308544,14 6.47935907,13.5977011 6.47935907,13.1149425 C6.47935907,13.1149425 6.47935907,11.7471264 6.47935907,11.1034483 C6.47935907,10.7011494 6.73512324,10.3793103 7.07614214,10.2988506 C9.3780197,9.65517241 10.9978595,7.56321839 10.9978595,5.31034483 C11.0831142,2.4137931 8.61072718,0 5.5415571,0 C2.47238701,0 0,2.33333333 0,5.22988506 Z",
    id: "Path"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpIcon);
export default __webpack_public_path__ + "static/media/help-icon.c4de2998b74d832fb46aba37fe4e457d.svg";
export { ForwardRef as ReactComponent };